import { Box, Divider, Paper, Typography } from "@mui/material";
import React from "react";
import { CardStyle } from "./Card.style";
import { useAuth } from "../../../../../context/Auth.context";

const CardComponent = (props) => {
  const auth = useAuth();
  const {
    leftLabel,
    leftValue,
    rightLabel,
    rightValue,
    leftText,
    leftContent,
    rightText,
    rightContent,
    rightDisabled = false,
    leftDisabled = false,
  } = props;

  return (
    <>
      <Box sx={CardStyle.wrapperBox}>
        <Paper sx={CardStyle.wrapperPaper}>
          <Box sx={CardStyle.content}>
            <Box sx={CardStyle.input}>
              <Typography
                textAlign="center"
                // variant="h5"
                sx={{
                  ...CardStyle.textInside,
                  opacity: leftDisabled ? 0.5 : 1,
                  pointerEvents: leftDisabled ? "none" : "auto",
                }}
              >
                {leftValue}
              </Typography>
              <Typography
                textAlign="center"
                variant="body2"
                sx={{
                  ...CardStyle.text,
                  opacity: leftDisabled ? 0.5 : 1,
                  pointerEvents: leftDisabled ? "none" : "auto",
                }}
              >
                {leftLabel}
              </Typography>

              {(leftText !== undefined || leftContent !== undefined) && (
                <>
                  <Typography textAlign="center" sx={CardStyle.textInside}>
                    {leftText}
                  </Typography>
                  <Typography textAlign="center" variant="body2">
                    {leftContent}
                  </Typography>
                </>
              )}
            </Box>
          </Box>
          <Divider orientation="vertical" />
          <Box sx={CardStyle.content}>
            <Box sx={CardStyle.input}>
              <Typography
                textAlign="center"
                // variant="h5"
                sx={{
                  ...CardStyle.textInside,
                  opacity: rightDisabled ? 0.5 : 1,
                  pointerEvents: rightDisabled ? "none" : "auto",
                }}
              >
                {rightValue}
              </Typography>
              <Typography
                textAlign="center"
                variant="body2"
                sx={{
                  ...CardStyle.text,
                  opacity: rightDisabled ? 0.5 : 1,
                  pointerEvents: rightDisabled ? "none" : "auto",
                }}
              >
                {rightLabel}
              </Typography>

              {(rightText !== undefined || rightContent !== undefined) && (
                <>
                  <Typography textAlign="center" sx={CardStyle.textInside}>
                    {rightText}
                  </Typography>
                  <Typography
                    textAlign="center"
                    variant="body2"
                    sx={CardStyle.text}
                  >
                    {rightContent}
                  </Typography>
                </>
              )}
            </Box>
          </Box>
        </Paper>
      </Box>
    </>
  );
};

export default CardComponent;
